import { User } from 'firebase/auth';

export const initiatePinterestConnection = async (user: User): Promise<void> => {
  if (!user) {
    throw new Error('You must be signed in to connect Pinterest.');
  }

  try {
    const token = await user.getIdToken();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/pinterest/url?token=${encodeURIComponent(token)}`);

    if (!response.ok) {
      throw new Error('Failed to get authorization URL');
    }

    const { authUrl } = await response.json();
    localStorage.setItem('pinterest_return_path', window.location.pathname);
    window.location.href = authUrl;
  } catch (error) {
    console.error('Error initiating Pinterest OAuth:', error);
    throw new Error('Failed to connect to Pinterest. Please try again.');
  }
};

export const disconnectPinterest = async (user: User): Promise<void> => {
  const token = await user.getIdToken();
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/pinterest/disconnect`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error('Failed to disconnect Pinterest');
  }
};
